/*
 *
 * EditTerminalPopup
 *
 * @version 1.0.0
 * @author Andrea Pinardi
 * @since 13-Jan-2025
 */

import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import EditTerminalPopup from './EditTerminalPopup'
import * as TerminalsManagementActions from 'Route/TerminalsManagement/modules/TerminalsManagementActions'
import { userPermissions } from 'Store/selectors'
import { doPopup } from 'Store/actions/popup'

const mapDispatchToProps = (dispatch) => ({
  ...bindActionCreators(TerminalsManagementActions, dispatch),
  closePopup: () => dispatch(doPopup(''))
})

const mapStateToProps = (state) => ({
  terminal: state?.popup?.popupData?.terminal || {},
  isUpdatingTerminal: state?.loading?.local_terminalConfiguration || false,
  userPermissions: userPermissions(state)
})

export default connect(mapStateToProps, mapDispatchToProps, (stateProps, dispatchProps, mergeProps) => ({
  ...stateProps,
  ...mergeProps,
  actions: dispatchProps
}))(EditTerminalPopup)
